export const hpToKw = hp => Math.round(hp / 1.341)
